import React, { lazy } from 'react';
import { TwitterIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-darkest border-t border-white/10 pt-16 pb-8" data-id="element-207">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-208">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-209">
          <div className="col-span-1 md:col-span-2" data-id="element-210">
            <div className="flex items-center mb-6" data-id="element-211">
              <img src="https://cdn.magicpatterns.com/uploads/rX3SBp63zs47X13CcgwCHd/IMG_2082.png" alt="Qtap" className="h-16 w-auto brightness-0 invert" loading="lazy" data-id="element-212" />
            </div>
            <p className="text-gray-400 max-w-sm mb-4" data-id="element-213">
              The world's first NFC-enabled smart t-shirt. Merging premium
              sportswear with dynamic digital identity.
            </p>
            <p className="text-gray-500 text-sm" data-id="element-214">
              Developed by{' '}
              <a href="https://stdiglobal.com/" target="_blank" rel="noopener noreferrer" className="text-brand-cyan hover:text-brand-sky transition-colors font-medium" data-id="element-215">
                STDI Global
              </a>
            </p>
          </div>

          <div data-id="element-216">
            <h4 className="font-bold text-white mb-6" data-id="element-217">Links</h4>
            <ul className="space-y-4" data-id="element-218">
              <li data-id="element-219">
                <a href="#how-it-works" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-220">
                  How It Works
                </a>
              </li>
              <li data-id="element-221">
                <a href="#features" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-222">
                  Features
                </a>
              </li>
              <li data-id="element-223">
                <a href="#pricing" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-224">
                  Pricing & Pre-order
                </a>
              </li>
              <li data-id="element-225">
                <a href="#faq" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-226">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-227">
            <h4 className="font-bold text-white mb-6" data-id="element-228">Legal</h4>
            <ul className="space-y-4" data-id="element-229">
              <li data-id="element-230">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-231">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-232">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-233">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-234">
                <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-235">
                  Contact Us
                </a>
              </li>
            </ul>
            <div className="flex gap-4 mt-8" data-id="element-236">
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-237">
                <TwitterIcon className="w-5 h-5" data-id="element-238" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-239">
                <InstagramIcon className="w-5 h-5" data-id="element-240" />
              </a>
              <a href="#" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-241">
                <LinkedinIcon className="w-5 h-5" data-id="element-242" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row items-center justify-between text-sm text-gray-500" data-id="element-243">
          <p data-id="element-244">
            © {new Date().getFullYear()} Qtap Smart Apparel. All rights
            reserved.
          </p>
          <p className="mt-2 md:mt-0" data-id="element-245">
            Developed by{' '}
            <a href="https://stdiglobal.com/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-brand-cyan transition-colors" data-id="element-246">
              STDI Global
            </a>
          </p>
        </div>
      </div>
    </footer>;
}